import { ReactComponent as ErrorFallbackImage } from '../../assets/icons/error-page.svg';
import CustomButton from '../../shared/components/Buttons/CustomButton/CustomButton';

import './ErrorFallback.scss';

const ErrorFallback = () => {
  const reloadPage = () => {
    globalThis.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center w-full error-fallback">
      <ErrorFallbackImage className="error-fallback__image" aria-hidden="true" focusable="false" />
      <div className="error-fallback__title">Oops! The information could not be loaded</div>
      <div className="error-fallback__description-container">
        <div className="error-fallback__description">Please try again now or later.</div>
      </div>
      <CustomButton onClick={reloadPage} variant="secondary" size="l">
        Try again
      </CustomButton>
    </div>
  );
};

export default ErrorFallback;
